import React, { useCallback, useMemo } from "react";
import classnames from "classnames";
import { Icon, Table } from "@shared/components";
import { stationIssuesTableProperties } from "@containers/Station/constants/stationIssuesTableProperties";
import { StationIssue } from "@shared/models";
import { HospitalCardEmptyState } from "@containers/Dashboard/components/DashboardHospitalContainer/HospitalCardEmptyState";

import "./index.scss";

interface StationIssuesListProps {
  title: string;
  className?: string;
  issues: StationIssue[];
  emptyState?: string;
  onClose: () => void;
  onRowClick: (item: StationIssue) => void;
  onClickMarkAsRead: (issue: StationIssue) => void;
  loadNextPage: () => void;
}

const StationIssuesList = (props: StationIssuesListProps) => {
  const { title, className, onClose, issues, loadNextPage, emptyState, onRowClick, onClickMarkAsRead } = props;

  const isEmpty = useMemo(() => !issues.length, [issues]);

  const handleRowClick = useCallback(
    (item: StationIssue) => {
      onRowClick?.(item);
      onClose();
    },
    [onRowClick, onClose],
  );

  const tableProperties = useMemo(() => {
    return stationIssuesTableProperties(onClickMarkAsRead, handleRowClick);
  }, [handleRowClick, onClickMarkAsRead]);

  return (
    <div className={classnames("station-notifications-list", className)}>
      <div className={classnames("station-notifications-list-title", { "station-notifications-list-empty": isEmpty })}>
        <div className="station-notifications-list-title-content">{title}</div>
        <div onClick={onClose} className="station-notifications-list-title-action">
          <Icon type="clear" />
        </div>
      </div>
      <div className={classnames("station-notifications-list-content", { empty: isEmpty })}>
        {!isEmpty ? (
          <Table<StationIssue>
            items={issues}
            properties={tableProperties}
            onFinishScroll={loadNextPage}
            isDisabledHoverRow={false}
          />
        ) : (
          <HospitalCardEmptyState title={emptyState} />
        )}
      </div>
    </div>
  );
};

export default StationIssuesList;
